import React from 'react'
// import HeaderStart from './components/HeaderStart'
// import Box from './components/Box'
import './App.css'
import Routes from './routes'
// eslint-disable-next-line
export default (props) =>
    <div className='App'>

        {/* <Box/> */}
        <Routes />

    </div>